import React, { memo, useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { areEqual } from 'Utils/equalityChecks';
import { useCustomReports } from 'Context/CustomReports';
import { ReportCard } from '../ReportCard/ReportCard';
import classes from './equipmentChart.module.css';

function EquipmentChart() {
  const { equipmentDeployments }: any = useCustomReports();
  const { data, loading, error } = equipmentDeployments;

  const chartData = useMemo(() => {
    if (!data || data.length === 0) return [];

    const sums: Record<string, number> = {};
    data.forEach((row: any) => {
      const name = row['equipment.name'] || 'Unknown';
      const qty = parseInt(row['deployment.quantity'], 10) || 1;
      sums[name] = (sums[name] || 0) + qty;
    });

    return Object.entries(sums)
      .map(([name, quantity]) => ({ name, quantity }))
      .sort((a, b) => b.quantity - a.quantity)
      .slice(0, 15);
  }, [data]);

  return (
    <ReportCard
      title="Equipment Deployments"
      subtitle="Active equipment deployed across projects"
      loading={loading}
      error={error}
      configKey="equipmentDeployments"
    >
      {chartData.length > 0 ? (
        <div className={classes.chartWrapper}>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 60 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" angle={-45} textAnchor="end" tick={{ fontSize: 11 }} interval={0} height={80} />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="quantity" fill="#9A00FF" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <p className={classes.emptyState}>No equipment deployment data available.</p>
      )}
    </ReportCard>
  );
}

const EquipmentChartMemo = memo(EquipmentChart, areEqual);
export { EquipmentChartMemo as EquipmentChart };
